import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type RecordGuestPreferenceByGuestSessionMutationVariables = Types.Exact<{
  input: Types.RecordGuestPreferenceInput;
}>;

export type RecordGuestPreferenceByGuestSessionMutation = {
  __typename?: 'Mutation';
  recordGuestPreferenceByGuestSession: { __typename?: 'RecordGuestPreferenceResult'; accepted: boolean };
};

export const RecordGuestPreferenceByGuestSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RecordGuestPreferenceByGuestSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RecordGuestPreferenceInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordGuestPreferenceByGuestSession' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accepted' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RecordGuestPreferenceByGuestSessionMutationFn = Apollo.MutationFunction<
  RecordGuestPreferenceByGuestSessionMutation,
  RecordGuestPreferenceByGuestSessionMutationVariables
>;

/**
 * __useRecordGuestPreferenceByGuestSessionMutation__
 *
 * To run a mutation, you first call `useRecordGuestPreferenceByGuestSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordGuestPreferenceByGuestSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordGuestPreferenceByGuestSessionMutation, { data, loading, error }] = useRecordGuestPreferenceByGuestSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordGuestPreferenceByGuestSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<RecordGuestPreferenceByGuestSessionMutation, RecordGuestPreferenceByGuestSessionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<RecordGuestPreferenceByGuestSessionMutation, RecordGuestPreferenceByGuestSessionMutationVariables>(
    RecordGuestPreferenceByGuestSessionDocument,
    baseOptions,
  );
}
export type RecordGuestPreferenceByGuestSessionMutationHookResult = ReturnType<typeof useRecordGuestPreferenceByGuestSessionMutation>;
export type RecordGuestPreferenceByGuestSessionMutationResult = Apollo.MutationResult<RecordGuestPreferenceByGuestSessionMutation>;
export type RecordGuestPreferenceByGuestSessionMutationOptions = Apollo.BaseMutationOptions<
  RecordGuestPreferenceByGuestSessionMutation,
  RecordGuestPreferenceByGuestSessionMutationVariables
>;
